import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { parseUnits } from '@ethersproject/units';
import { CurrencyAmount as CurrencyAmountRaw } from '@uniswap/sdk-core';
import { FeeAmount } from '@uniswap/v3-sdk';
import JSBI from 'jsbi';
export var CurrencyAmount = /*#__PURE__*/function (_CurrencyAmountRaw) {
  _inherits(CurrencyAmount, _CurrencyAmountRaw);

  var _super = _createSuper(CurrencyAmount);

  function CurrencyAmount() {
    _classCallCheck(this, CurrencyAmount);

    return _super.apply(this, arguments);
  }

  return _createClass(CurrencyAmount);
}(CurrencyAmountRaw); // Try to parse a user entered amount for a given token

export function parseAmount(value, currency) {
  var typedValueParsed = parseUnits(value, currency.decimals).toString();
  return CurrencyAmount.fromRawAmount(currency, JSBI.BigInt(typedValueParsed));
}
export function parseFeeAmount(feeAmountStr) {
  switch (feeAmountStr) {
    case '10000':
      return FeeAmount.HIGH;

    case '3000':
      return FeeAmount.MEDIUM;

    case '500':
      return FeeAmount.LOW;

    case '100':
      return FeeAmount.LOWEST;

    default:
      throw new Error("Fee amount ".concat(feeAmountStr, " not supported."));
  }
}
export function unparseFeeAmount(feeAmount) {
  switch (feeAmount) {
    case FeeAmount.HIGH:
      return '10000';

    case FeeAmount.MEDIUM:
      return '3000';

    case FeeAmount.LOW:
      return '500';

    case FeeAmount.LOWEST:
      return '100';

    default:
      throw new Error("Fee amount ".concat(feeAmount, " not supported."));
  }
}